import { useGlobal } from '@/utils/useGlobal';
import { LineSpace } from '@/components/ProductComponents';
import TextWithImage from '@/components/ProductDetailComponents/TextWithImage';
import TextOnImage from '@/components/ProductDetailComponents/TextOnImage';
import { getDetaileMoreProducts } from '@/utils';
import { getImageLocal } from '@/utils/locals';
import OtherList from '@/components/ProductCommon/OtherList';
import { createEFPic } from '@/utils/useEFPic';
const { EFPic } = createEFPic('/media/solartracker/pc/');

export default function SolarTracker() {
    const { gloproductlist, useLang, useRouter } = useGlobal();
    const { t } = useLang('solartracker');
    const { locale } = useRouter();
    const imgLocal = getImageLocal(locale, ['jp', 'de', 'fr', 'cn']);
    const webpUrl = '/media/solartracker/pc/';
    const textWithImgItem1 = {
        title: t('solar_tracker.third_title'),
        synopsis: t('solar_tracker.third_subtitle'),
        desc: `${t('solar_tracker.third_des_gray')} <span style="color:#000">${t('solar_tracker.third_des_black')}</span>`,
        img_url: ['solartracker1.webp', 'solartracker1.jpg'],
        noUseHtmlAttr: true,
    };
    const textOnImgItem1 = {
        title: t('solar_tracker.four_title'),
        synopsis: t('solar_tracker.four_subtitle'),
        desc: t('solar_tracker.four_des'),
        phrase: t('solar_tracker.four_text'),
        bgImgs: ['solartracker2.webp', 'solartracker2.jpg'],
    };
    const textWithImgItem2 = {
        synopsis: `${t('solar_tracker.five_title')}</br>${t('solar_tracker.five_subtitle')}`,
        alt: t('solar_tracker.five_title') + t('solar_tracker.five_subtitle'),
        desc: t('solar_tracker.five_des'),
        img_url: ['solartracker3.webp', 'solartracker3.jpg'],
    };

    const textOnImgItem2 = {
        synopsis: t('solar_tracker.six_title'),
        alt: t('solar_tracker.six_title'),
        desc: t('solar_tracker.six_des'),
        bgImgs: [`solartracker4_${imgLocal}.webp`, `solartracker4_${imgLocal}.jpg`],
    };
    const otherProduct = getDetaileMoreProducts(
        gloproductlist,
        ['product_sp_400w_solar_panel', 'product_sp_160w_solar_panel', 'product_sp_110w_solar_panel'],
        '',
        '',
        locale === 'us' ? 'https://us.ecoflow.com/collections/solar-generators' : `https://${locale}.ecoflow.com/collections/solar-panels`,
    );
    return (
        <>
            <div className="banner-content">
                <div className="section section1">
                    <h3 className="tit">{t('solar_tracker.ytdd_sec1_tit')}</h3>
                    {/* 非 it 站 */}
                    {!['it'].includes(locale) && (
                        <>
                            <p className="subtit">{t('solar_tracker.ytdd_sec1_subtit1')}</p>
                            <p className="subtit">{t('solar_tracker.ytdd_sec1_subtit2')}</p>
                        </>
                    )}
                    {['it'].includes(locale) && (
                        <>
                            <p className="subtit">
                                {t('solar_tracker.ytdd_sec1_subtit1')}
                                {` ${t('solar_tracker.ytdd_sec1_subtit2')}`}
                            </p>
                        </>
                    )}

                    <div className="bg-img">
                        <EFPic name={['section1.webp', 'section1.jpg']} className="fullImgs" alt={t('Solar Tracker')} />
                    </div>
                </div>
                <div className="section section2">
                    <h3 className="tit">
                        {t('solar_tracker.ytdd_sec2_tit')}
                        <span className="union">{t('solar_tracker.ytdd_sec2_union')}</span>
                    </h3>
                    {!['it'].includes(locale) && (
                        <>
                            <p className="subtit">{t('solar_tracker.ytdd_sec2_subtit1')}</p>
                            <p className="subtit">{t('solar_tracker.ytdd_sec2_subtit2')}</p>
                        </>
                    )}
                    {['it'].includes(locale) && (
                        <>
                            <p className="subtit">
                                {t('solar_tracker.ytdd_sec2_subtit1')}
                                {` ${t('solar_tracker.ytdd_sec2_subtit2')}`}
                            </p>
                        </>
                    )}
                    <div className="bg-img">
                        <EFPic name={['section2.webp', 'section2.jpg']} className="fullImgs" alt={t('Solar Tracker')} />
                    </div>
                </div>
                <div className="section section3">
                    <h3 className="tit">{t('solar_tracker.ytdd_sec3_tit')}</h3>
                    <p className="subtit">{t('solar_tracker.ytdd_sec3_subtit1')}</p>
                    <p className="subtit">{t('solar_tracker.ytdd_sec3_subtit2')}</p>
                    <div className="bg-img">
                        <EFPic name={['section3.webp', 'section3.jpg']} className="fullImgs" alt={t('Solar Tracker')} />
                    </div>
                </div>
                <div className="section section4">
                    <h3 className="tit">{t('solar_tracker.ytdd_sec4_tit')}</h3>
                    <div className="bg-img">
                        <EFPic name={['section4.webp', 'section4.jpg']} className="fullImgs" alt={t('Solar Tracker')} />
                    </div>
                </div>
                <div className="section section5">
                    <h3 className="tit">{t('solar_tracker.ytdd_sec5_tit')}</h3>
                    <div className="bg-img">
                        <EFPic name={['section5.webp', 'section5.jpg']} className="fullImgs" alt={t('Solar Tracker')} />
                    </div>
                </div>
                <div className="section section6">
                    <h3 className="tit">{t('solar_tracker.ytdd_sec6_tit')}</h3>
                    <p className="subtit">{t('solar_tracker.ytdd_sec6_subtit1')}</p>
                    <div className="bg-img">
                        <EFPic name={['section6.webp', 'section6.jpg']} className="fullImgs" alt={t('Solar Tracker')} />
                    </div>
                </div>
                <div className="section section7">
                    <h3 className="tit">{t('solar_tracker.ytdd_sec7_tit')}</h3>
                    <p className="subtit">{t('solar_tracker.ytdd_sec7_subtit1')}</p>
                    <div className="bg-img">
                        <EFPic name={['section7.webp', 'section7.jpg']} className="fullImgs" alt={t('Solar Tracker')} />
                    </div>
                </div>
            </div>
            <LineSpace height="md" background="#fff" />
            <TextWithImage
                data={textWithImgItem1}
                config={{
                    position: 'top',
                    titleFontSize: 32,
                    imgHeight: '1080px',
                    imgWidth: '100%',
                    descFontSize: locale === 'jp' ? '20' : '22',
                    webpUrl,
                }}
            />
            <LineSpace height="lg" background="#fff" />
            <div
                className="text-image"
                style={{
                    height: (() => {
                        const mapHeight = {
                            es: '1180px',
                        };
                        type Asmapheight = keyof typeof mapHeight;
                        return mapHeight[locale as Asmapheight] || '1080px';
                    })(),
                }}
            >
                <TextOnImage
                    config={{
                        position: 'top',
                        titleColor: '#121212',
                        titleFontSize: 32,
                        synopsisColor: '#03060b',
                        synopsisFontSize: locale === 'fr' ? 52 : 64,
                        descColor: '#666',
                        phraseColor: '#666',
                        descFontSize: locale === 'jp' || locale === 'cn' ? '20' : '22',
                        webpUrl,
                        imageMarginTop: (() => {
                            const map = {
                                jp: '90px',
                                fr: '20px',
                                it: '60px',
                            };
                            return map[locale as keyof typeof map] || '0px';
                        })(),
                        imgHeight: (() => {
                            const mapHeight = {
                                es: '1180px',
                            };
                            type Asmapheight = keyof typeof mapHeight;
                            return mapHeight[locale as Asmapheight] || '1080px';
                        })(),
                    }}
                    data={textOnImgItem1}
                />
            </div>
            <LineSpace height="xxl" background="#fff" />
            <LineSpace height="sm" background="#fff" />
            <TextWithImage
                config={{
                    position: 'top',
                    descFontSize: locale === 'jp' ? '20' : '22',
                    webpUrl,
                    width: (() => {
                        const mapHeight = {
                            es: '954px',
                        };
                        type Asmapheight = keyof typeof mapHeight;
                        return mapHeight[locale as Asmapheight] || '924px';
                    })(),
                }}
                data={textWithImgItem2}
            />
            <LineSpace height="lg" background="#fff" />
            <TextOnImage
                config={{
                    imgHeight: '900px',
                    position: 'left',
                    gradient: true,
                    gradientColor: 'linear-gradient(353deg, rgb(240, 128, 134) 12%, rgb(255, 150, 43) 118%)',
                    synopsisLineHeight: locale === 'fr' ? 1.26 : 1.13,
                    descFontSize: locale === 'jp' ? '20' : '22',
                    synopsisFontSize: locale === 'cn' ? '60' : '64',
                    webpUrl,
                }}
                data={textOnImgItem2}
            />
            <LineSpace height="xxl" background="#fff" />
            <div className="container">
                <OtherList data={otherProduct} />
            </div>
        </>
    );
}
